import { OrderPaymentReceiptComponent } from './orderPaymentReceipt.component';
export { OrderPaymentReceiptComponent };
